import { StockEvent } from "../models/stock/stock-event"
import { httpGet, httpPost } from "./http";

const apiUrl = 'api/stock';

export const getActiveStockEvent = () => httpGet<StockEvent>(`${apiUrl}/activestockevent`);
export const saveStockEvent = (stockEvent: StockEvent) => httpPost<StockEvent>(`${apiUrl}/savestockevent`, stockEvent);
